import {combineReducers} from 'redux';
import authReducer from './authReducer';
import publicReducer from './public'
import configReducer from './configReducer';

export default combineReducers ({
    auth: authReducer,
    config: configReducer,
    public: publicReducer
});